import { Link } from "@/lib/router-compat";
import { Star } from "lucide-react";
import { COMPANY } from "@/lib/seo";

const testimonials = [
  { name: "John R.", text: "Service was top notch. One of the best company's I have had the pleasure of doing business with. The work crew is full of energetic knowledgeable employees. I would recommend them to anyone." },
  { name: "Debbie S.", text: "They were very responsive and professional. After being without power for 3 days, they had us up and running within 24 hours of calling them. EXCELLENT SERVICE!!!" },
  { name: "Malachi H.", text: "I had some electric work that I needed completed. Hadley Energy Solutions went above and beyond what I was expecting. Top notch service, top notch company. Would definitely recommend!" },
];

/**
 * Three-testimonial row — the homepage §8 block, reused on inner pages.
 * Replaces the old single-quote ReviewSlider carousel.
 */
const TestimonialRow = () => (
  <section className="border-y border-border bg-background">
    <div className="container py-10 md:py-12">
      <p className="font-condensed text-[13px] font-bold uppercase tracking-[0.12em] text-primary">Customer Reviews</p>
      <h2 id="what-our-customers-say" className="mt-2 font-heading text-[30px] font-bold leading-tight tracking-[-0.01em]">What Our Customers Say</h2>
      <div className="mt-8 grid gap-6 md:grid-cols-3">
        {testimonials.map((review) => (
          <figure key={review.name} className="rounded-[4px] border border-border bg-card p-6">
            <div className="flex gap-0.5" aria-label="5 star rating">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className="h-4 w-4 fill-primary text-primary" aria-hidden="true" />
              ))}
            </div>
            <blockquote className="mt-4 font-body text-[15px] leading-relaxed text-foreground/90">"{review.text}"</blockquote>
            <figcaption className="mt-4 font-heading text-sm font-bold">— {review.name}</figcaption>
          </figure>
        ))}
      </div>
      <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2">
        <Link to="/reviews" className="font-condensed text-[13px] font-bold uppercase tracking-[0.12em] text-primary hover:underline">
          Read All Reviews
        </Link>
        <a href={COMPANY.googleReviews} target="_blank" rel="noopener noreferrer" className="font-condensed text-[13px] font-bold uppercase tracking-[0.12em] text-primary hover:underline">
          Read More Reviews on Google
        </a>
      </div>
    </div>
  </section>
);

export default TestimonialRow;
